// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"197":"253c72b1","693":"c9cf84ff","827":"a0ed7e08"}[chunkId] + ".js";
};